import { SelfSchedulePatient } from "@/types/self-schedule";

import { requestData } from "@/api/api-config";

export interface SelfSchedulePatientDetails {
  phoneNumber?: string;
  email?: string;
  zipCode: string;
  dateOfBirth: string | null;
  leadSource?: string | null;
}

export async function updateSelfSchedulePatientDetails(
  patientId: string,
  details: SelfSchedulePatientDetails,
): Promise<SelfSchedulePatient> {
  const patient = await requestData<SelfSchedulePatient>(
    `auth/patient/${patientId}/self-schedule-details`,
    "put",
    { json: details },
    false,
  );
  if (!patient)
    throw new Error("Your details could not be saved. Please try again.");
  return patient;
}
